// components/SeekerDetails/SeekerDetails.tsx
import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Seeker } from "../../../types/seatApproval";
import styles from "./index.module.scss";
import UserCard from "./Common/UserCards";
import VideoSection from "./Common/VideoSection";
import QuestionsSection from "./Common/QuestionsSection";
import RatingSection from "./Common/RatingSection";
import QuerySection from "./Common/Questions";
import Drawer from "@mui/material/Drawer";
import graphImage from "../../../assets/images/yearGraph.png";
import { Button } from "../../../common/components/Button";
import videoImage from "../../../assets/images/videoImg.png";

import { sortPreferences } from "../../../utils/dataMapper";
import TabsComponent from "../../AllProgramsList/SeekerDashboardHdb/TabsComponent";
import CommonPlaneTabs from "../../../common/components/CommonPlaneTabs";
import MessageSection from "../../MessageSection";
import BackArrow from "../../../assets/images/session_overlay_back_arrow.svg";
import SessionsCard from "./programSessions";
import { useResponsive } from "../../../utils/functions";

interface Session {
  id: string | number;
  name: string;
  type: string;
  assignedUsers: any[];
  allocatedCount: number;
  totalSeekers: number;
}
interface SeekerDetailsProps {
  isOpen: boolean;
  onClose: () => void;
  seekerDetails: Seeker | null;
  getInitials?: (name: string) => string;
  isGroupedProgram?: boolean; // Optional prop to indicate if the program is grouped
  sessions: Session[]; // Replace with actual type if available
  onBless: (sessionId: number) => void; // Function to handle blessing a
  user: any;
  handleBlessed?: (seekerId: number,
    targetProgramId: number,
    swapType: string,
    swapRequestId?: number) => void;
  currentProgram?: string;
  availablePrograms?: Session[];
  onProgramSelect?: (program: any) => void;
  onCancel?: () => void;
  programId?: string;
  handleSwapUser?: (user: any, programId: any) => void;
  selectedSwapProgram?: any;
  selectedSwapUser?: any;
  selectedOption?: any; // Replace with actual type if available
}

const SeekerDetails: React.FC<SeekerDetailsProps> = ({
  isOpen,
  onClose,
  seekerDetails,
  getInitials,
  isGroupedProgram,
  sessions,
  onBless,
  user,
  handleBlessed,
  currentProgram,
  availablePrograms,
  onProgramSelect,
  onCancel,
  programId,
  handleSwapUser,
  selectedSwapProgram,
  selectedSwapUser,
  selectedOption,
}) => {
  const [loading, setLoading] = useState(false);
  // console.log("SeekerDetailssss", seekerDetails.ratings);
  const [seekerData, setSeekerData] = useState<Seeker | null>(seekerDetails);
  const [selectedTab, setSelectedTab] = useState<number>(0);
  // Mock data - replace with API call
  const passion = 2;
  const growth = 3;
  const infiniteness = 3;
  const continuity = 4;
  const overall = ((passion + growth + infiniteness + continuity) / 4).toFixed(
    1,
  );
  console.log("Seession Details in SeekerDetails:", sessions);
  console.log("SessionsCard user:", user);
  const mockSeekerData: Seeker = {
    name: "Anjan Kumar",
    gender: "M",
    age: 34,
    programs: "03 Programs",
    location: "Chennai",
    appliedDate: "24 Jan 2023, 16:19:07",
    hdbLevels: ["HDB 1", "HDB 2", "HDB 3", "MSD 1", "MSD 2"],
    completedLevels: {
      "HDB 2": 1,
      "HDB 3": 2,
      "MSD 1": 1,
    },
    journeyYears: "3yrs of his infini journey",
    profileImage: "/api/placeholder/300/400",
    videoThumbnail: "/api/placeholder/300/200",
    roommate: {
      name: "Praveen Yadav",
      preference: "Roommate preference",
    },
    questions: [
      {
        id: 1,
        question: "What are your 3 most dominant emotions?",
        answer:
          "Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum",
      },
      {
        id: 2,
        question: "Mention any 3 qualities that best describe you?",
        answer:
          "Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum",
      },
    ],
    rating: {
      overall,
      passion,
      growth,
      infiniteness,
      continuity,
    },
    review:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla aliquam bibendum dui, nec lacinia magna. Aliquam lacinia augue ut ante consequat faucibus. Fusce rutrum, lorem vitae dictum dapibus.",
    reviewer: "Praveen Kumar assigned as a RM for Anjan Kumar",
  };

  useEffect(() => {
    if (isOpen && !seekerData) {
      fetchSeekerData();
    }
  }, [isOpen, seekerData]);

  const fetchSeekerData = async () => {
    setLoading(true);
    try {
      setTimeout(() => {
        setSeekerData(seekerDetails);
        setLoading(false);
      }, 500);
    } catch (error) {
      console.error("Error fetching seeker data:", error);
      setLoading(false);
    }
  };

  const handlePlayVideo = () => {
    console.log("Play video clicked");
  };

  const handleShowAllQuestions = () => {
    console.log("Show all questions clicked");
  };

  const handleSendQuery = (query: string, selectedUser: string) => {
    console.log("Send query:", { query, selectedUser });
  };

  if (!isOpen) return null;

  const [preferenceData, setPreferenceData] = useState<string[]>([]);

  useEffect(() => {
    if (seekerData) {
      setPreferenceData(sortPreferences(seekerData.preferences || [], true));
    }
  }, [seekerData]);
  console.log("Preference Data:", preferenceData);
  const handleTabChange = (newValue: number) => {
    setSelectedTab(newValue);
  };
  console.log("Seeker Data:", seekerData);
  return (
    <Drawer anchor={"right"} open={isOpen} onClose={onClose}>
      <div
        className={`${styles.seekerDetailsModal} ${isOpen ? styles.open : ""}`}
      >
        <div className={styles.modalHeader}>
          <img src={BackArrow} alt="Back" className={styles.backButton} onClick={onClose} />
          <span>Seeker Details</span>
          {/* <button className={styles.closeButton} onClick={onClose}> */}

          <X size={26} onClick={onClose} className={styles.closeButton} />

          {/* </button> */}
        </div>

        <div className={styles.modalContent}>
          {loading ? (
            <div className={styles.loading}>Loading...</div>
          ) : seekerData ? (
            <>
              <UserCard
                seeker={seekerData}
                preferenceData={preferenceData}
                sessions={sessions}
                onBless={onBless}
                onClose={onClose}
                user={user}
                handleBlessed={handleBlessed}
                currentProgram={currentProgram}
                availablePrograms={availablePrograms}
                onProgramSelect={onProgramSelect}
                onCancel={onCancel}
                programId={programId}
                selectedSwapProgram={selectedSwapProgram}
                selectedSwapUser={selectedSwapUser}
                handleSwapUser={handleSwapUser}
                selectedOption={selectedOption}
              />
              <div className={styles.tabsContainer}>
                <CommonPlaneTabs
                  tabs={[{ label: "Details" }, { label: "Messages" }]}
                  onTabChange={handleTabChange}
                />
              </div>
              {selectedTab === 0 && (
                <div className={styles.modalContent}>
                  {/* <div className={styles.journeyInfo}>
                    <div className={styles.journeyIndicators}>
                      <span className={styles.indicator}>
                        <span className={styles.hdb2}>●</span> HDB 2 -{" "}
                        <span className={styles.boldText}>1</span>
                      </span>
                      <span className={styles.indicator}>
                        <span className={styles.hdb3}>●</span> HDB 3 -{" "}
                        <span className={styles.boldText}>2</span>
                      </span>
                      <span className={styles.indicator}>
                        <span className={styles.msd1}>●</span> MSD 1 -{" "}
                        <span className={styles.boldText}>1</span>
                      </span>
                      <div className={styles.journeyText}>
                        have done in 3yrs of his infini journey
                      </div>
                    </div>
                  </div> */}
                  {/* <div className={styles.timeline}>
                    <img src={graphImage} alt="images " />
                  </div> */}
                  {/* <div className={styles.timeline}>
                    <img src={videoImage} alt="" />
                  </div> */}
                  <VideoSection
                    videoSrc={seekerData.videoUrl || ""}
                    // poster={videoImage}
                    className={styles.timeline}
                  />
                  {/* 
                  <VideoSection
                    videoSrc="https://www.youtube.com/watch?v=yMWz797RFPA"
                    poster={videoImage}
                  /> */}
                  {seekerData.questionResponses &&
                    seekerData.questionResponses.length > 0 && (
                      <QuestionsSection
                        questions={seekerData.questionResponses}
                        onShowAll={handleShowAllQuestions}
                      />
                    )}
                  <RatingSection
                    ratings={seekerDetails.ratings}
                    rmData={seekerDetails?.rmContactUser}
                    rmReview={seekerDetails?.rmReview}
                  />
                  {/* <QuerySection onSendQuery={handleSendQuery} /> */}
                </div>
              )}
              {selectedTab === 1 && (
                <MessageSection
                  data={seekerDetails}
                  defaultOpen={true}
                  messageSectionClass={styles.messageConstainer}
                  isRequiredHeader={false}
                ></MessageSection>
              )}
            </>
          ) : (
            <div className={styles.error}>Failed to load seeker data</div>
          )}
        </div>
        {/* <div className={styles.footer}>
          <div className={styles.textArea}>
            <textarea
              // value={query}
              // onChange={(e) => setQuery(e.target.value)}
              placeholder="Write question"
              className={styles.queryTextarea}
            />
          </div>
          <Button
            buttonClassName={styles.sendButtonText}
            buttonTextClassName={styles.sendButtonText}
            onClick={() => handleSendQuery("Sample query", "Praveen Kumar")}
          >
            send
          </Button>
        </div> */}
      </div>
    </Drawer>
  );
};

export default SeekerDetails;
